import { useState } from "react";
import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { AuthProvider } from "./contexts/AuthContext";
import { ToastProvider } from "./components/ui/ToastProvider";
import { ThemeProvider } from "./contexts/ThemeContext";
import SplashScreen from "./components/SplashScreen";
import CookieBanner from "./components/CookieBanner";

function App() {
  const [showSplash, setShowSplash] = useState(true);

  return (
    <>
      {showSplash && <SplashScreen onFinish={() => setShowSplash(false)} />}
      <I18nextProvider i18n={i18n}>
        <ToastProvider>
          <ThemeProvider>
            <AuthProvider>
              <BrowserRouter basename={__BASE_PATH__}>
                <AppRoutes />
                <CookieBanner />
              </BrowserRouter>
            </AuthProvider>
          </ThemeProvider>
        </ToastProvider>
      </I18nextProvider>
    </>
  );
}

export default App;
